import type { StateParams, StateService } from "@uirouter/angularjs";
import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IResponseWithLoading, ISite } from "App/Modules/Models";
import { FunctionalityType } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class SiteComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "$stateParams", "$state", "mmSitesRepository"];

    public site: IResponseWithLoading<ISite>;

    public siteId: string;

    public hasCareFunctionality = false;
    public hasMotionFunctionality = false;

    constructor(
        private readonly $scope: IScope,
        private readonly stateParams: StateParams,
        private readonly stateService: StateService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.sitesRepository.getSite(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result: IResponseWithLoading<ISite>) => {
                    this.site = result;
                    if (this.site.data) {
                        this.hasCareFunctionality = !!this.site.data.functionalityTypes?.includes(
                            FunctionalityType.Care,
                        );
                        this.hasMotionFunctionality = !!this.site.data.functionalityTypes?.includes(
                            FunctionalityType.MotionDetection,
                        );
                    }
                },
                (result) => {
                    this.site = result;
                },
            );
    }
}
